// Bridges the /v1/orders list projection to the manual-review worklist.
// An ingest-stage SKU hold is: push_failed && lifecycle received && exc_reason
// "sku not mapped: <MERCHANT_SKU>" (set by the BE ingest pipeline's fail()).
//
// Wire field names verified against src/api/schema.d.ts (Order schema, 2026-06-11):
//   id, marketplace, seller_name, lifecycle_status, push_failed, exc_reason, created_at.
// exc_reason is `string | undefined` in the schema (not null), but we accept null
// as well for defensive compatibility.

const SKU_HOLD_PREFIX = "sku not mapped: ";

export interface ReviewRow {
  orderId: string;
  marketplace: string;
  sellerName: string;
  merchantSku: string;
  createdAt: string;
}

// Raw shape of the fields we read from the orders list response. The endpoint
// returns more; we type only what this feature consumes.
// Fields are optional so the bridge accepts both the real BE projection and
// partial MSW fixtures without crashing.
export interface RawHeldOrder {
  id: string;
  marketplace?: string;
  seller_name?: string;
  lifecycle_status?: string;
  push_failed?: boolean;
  exc_reason?: string | null;
  created_at?: string;
}

export function parseUnmappedSku(excReason: string | null | undefined): string | null {
  if (!excReason?.startsWith(SKU_HOLD_PREFIX)) return null;
  const sku = excReason.slice(SKU_HOLD_PREFIX.length).trim();
  return sku.length > 0 ? sku : null;
}

export function toReviewRow(o: RawHeldOrder): ReviewRow | null {
  if (!o.push_failed || o.lifecycle_status !== "received") return null;
  const merchantSku = parseUnmappedSku(o.exc_reason);
  if (merchantSku === null) return null;
  return {
    orderId: o.id,
    marketplace: o.marketplace ?? "",
    sellerName: o.seller_name ?? "",
    merchantSku,
    createdAt: o.created_at ?? "",
  };
}
